const IMAGE_FILE_EXTENSIONS = new Set([
  'avif',
  'bmp',
  'gif',
  'heic',
  'heif',
  'ico',
  'jpeg',
  'jpg',
  'png',
  'svg',
  'tif',
  'tiff',
  'webp',
]);

export const getFileExtension = (filename: string): string => {
  const parts = filename.split('.');
  if (parts.length < 2) {
    return '';
  }
  if (parts[0] === '' && parts.length === 2) {
    return '';
  }
  return parts[parts.length - 1].toLowerCase();
};

export const isImageFile = (filename: string): boolean => {
  const extension = getFileExtension(filename);
  return extension !== '' && IMAGE_FILE_EXTENSIONS.has(extension);
};
